var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.79194 4.03999C7.04578 3.78615 7.45734 3.78615 7.71118 4.03999L11.2112 7.53999C11.465 7.79383 11.465 8.20539 11.2112 8.45923L7.71118 11.9592C7.45734 12.2131 7.04578 12.2131 6.79194 11.9592C6.5381 11.7054 6.5381 11.2938 6.79194 11.04L9.83232 7.99961L6.79194 4.95923C6.5381 4.70539 6.5381 4.29383 6.79194 4.03999Z","fill":"#585C62"}));
}

ChevronRight.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
